import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// StrictMode disabled to avoid "Maximum update depth exceeded" from double-invoked effects
// (toast/auth redirect effects are already guarded with refs; re-enable StrictMode once stable)
createRoot(document.getElementById("root")!).render(<App />);
